import { Box } from '@mui/system';
import React from 'react';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { Typography } from '@mui/material';

function SuccessBox({ text }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        mt: '200px',
      }}>
      <CheckCircleRoundedIcon
        data-testid="checkCircleRoundedIcon"
        color="success"
        sx={{ fontSize: '140px' }}
      />
      <Typography
        data-testid="successBox-text"
        variant="title"
        sx={{
          mt: '16px',
          lineHeight: '40px',
        }}>
        {text}
      </Typography>
    </Box>
  );
}

export default SuccessBox;
